<template lang="pug">
  ValidationProvider(:rules="`${rules}|phone:${phoneData ? phoneData.valid : false}`" v-slot="{ errors }")
    div.fantasy__input-phone.pt-3.mt-1.mb-2.pb-3(:class="[{'fantasy__input-phone--filled' : filled},{'fantasy__input-phone--active' : active},{'fantasy__input-phone--error' : errors.length > 0}]")
      label.fantasy__input-phone__label
        v-icon.pr-1(v-if="isRequired" color="red accent-2" size="12") mdi-asterisk
        | {{ label }}
      vue-tel-input(v-model="valuefield", :defaultCountry="defaultCountry" @validate="validePhone" placeholder="", :disabled="disabled" @input="inputFill" @focus="focus" @blur="blur")
    span.red--text.text--accent-2(v-if="errors.length > 0")
      v-icon(color="red accent-2") mdi-alert
      |  {{ errors[0] }}
</template>

<script>

  import PhoneNumber from 'awesome-phonenumber';

  export default {
    name: "BasePhoneField",
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      }
    },
    data:() => ({
      phoneData: null,
      valuefield: null,
      defaultCountry: null,
      active: false,
    }),
    computed: {
      isRequired(){
        return this.rules.includes('required');
      },
      filled(){
        return this.valuefield.length > 0;
      }
    },
    watch: {
      value: function(val){
        this.initValues(val);
      }
    },
    created(){
      this.initValues(this.value);
    },
    methods:{
      focus(){
        this.active = true;
      },
      blur(){
        this.active = false;
      },
      validePhone(val){
        this.phoneData = val;
      },
      inputFill(formattedNumber, { number }){
        this.$emit('input', number.international);
      },
      initValues(val){
        const iso2 = PhoneNumber(val).getRegionCode();
        if (iso2 != null){
          this.valuefield = PhoneNumber(val).getNumber('significant');
          this.defaultCountry = PhoneNumber(val).getRegionCode();
        } else {
          this.valuefield = '';
          this.defaultCountry = '';
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '@/styles/_variables.sass'

  .fantasy__input-phone
    position: relative
    &__label
      background-color: #fff
      padding-left: 4px
      padding-right: 6px
      position: absolute
      left: 60px
      top: 17px
      pointer-events: none
      transform-origin: top left
      transform: translateY(0) scale(1)
      transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)
    .vue-tel-input
      border-color: rgba(0, 0, 0, 0.42)
        // border-color: $primary
      &:hover
        border-color: rgba(0, 0, 0, 0.87)
      &:focus-within
        box-shadow: none
      input
        caret-color: $primary
    &--active
      .fantasy__input-phone
        &__label
          color: $primary
          transform: translateY(-17px) scale(0.75)
      .vue-tel-input
        border-color: $primary
        &:hover
          border-color: $primary
        &:focus-within
          border-color: $primary
    &--error
      .fantasy__input-phone
        &__label
          color: #FF5252
      .vue-tel-input
        border-color: #FF5252
        &:hover
          border-color: #FF5252
        &:focus-within
          border-color: #FF5252
    &--filled
      .fantasy__input-phone
        &__label
          transform: translateY(-17px) scale(0.75)


</style>